import { PREFERENCES_API } from '../values/preferences.values';
import { Preference } from '../models/preference.model';
import { IUserContentPreferencesParams } from '../params/user-content-preferences.params';
import { RequestProvider } from '@/shared/providers/request.provider';

class PreferencesServiceClass {

  getOrganizationPreferences(organizationId: number): Promise<any> {
    return RequestProvider
      .get(PREFERENCES_API.GET_ORGANIZATION_PREFERENCES
      .replace('{organizationId}', organizationId.toString()));
  }

  setOrganizationPreferences(preferences: Preference[], organizationId: number): Promise<void> {
    return RequestProvider.post(
      PREFERENCES_API.SET_ORGANIZATION_PREFERENCES
        .replace('{organizationId}', organizationId.toString()),
      preferences
    );
  }

  getContentPreferences(contentId: number): Promise<any> {
    return RequestProvider.get(PREFERENCES_API.GET_CONTENT_PREFERENCES
      .replace('{contentId}', contentId.toString()));
  }

  getClassContentPreferences(classId: number, contentId: number): Promise<any> {
    return RequestProvider.get(PREFERENCES_API.GET_CLASS_CONTENT_PREFERENCES
      .replace('{classId}', classId.toString())
      .replace('{contentId}', contentId.toString()));
  }

  getUserContentPreferences(params: IUserContentPreferencesParams) {
    return RequestProvider.get(PREFERENCES_API.USER_CONTENT_PREFERENCES
      .replace('{classId}', params.classId.toString())
      .replace('{contentId}', params.contentId.toString())
      .replace('{userId}', params.userId.toString()));
  }

  setUserContentPreferences(preferences: Preference[], params: IUserContentPreferencesParams): Promise<void> {
    return RequestProvider.post(PREFERENCES_API.USER_CONTENT_PREFERENCES
      .replace('{classId}', params.classId.toString())
      .replace('{contentId}', params.contentId.toString())
      .replace('{userId}', params.userId.toString()), preferences);
  }

}

export const PreferencesService = new PreferencesServiceClass();
